import { Injectable } from '@angular/core';
import { SchemasService } from '../../services/schemas.service';
import { ViewsService } from '../../services/views.service';
import { SCHEMA_TYPE } from '../../models/enums.model';
import { ROOM_POSITION } from '../models/cvds/v3.3';
import { ObjectUtils, PermissionService } from '@cv-invision/core';
import { PERMISSION } from '../../models/permission.model';

@Injectable({
	providedIn: 'root'
})
export class ScrollableItemsHelperService {

	get order(): any {
		return this.viewsServices.order;
	}
	get document(): any {
		return this.viewsServices.document;
	}
	get photos(): any {
		return this.viewsServices.photos;
	}

	constructor(
		private schemasS: SchemasService,
		private viewsServices: ViewsService,
		private userPermision: PermissionService
	) { }

	/**
	 * Get the List of the Scrollable Sections
	 */
	public getScrollableItems(): any {
		let scrollableItems = [];

		switch (this.order.schema) {
			case SCHEMA_TYPE.CVDS_32:
				scrollableItems = [...this.getItemsCVDS32()];
				break;
		}

		return scrollableItems;
	}

	/**
	 * get Scrollable Items from CVDS 3.2 order
	 */
	private getItemsCVDS32(): Array<any> {
		const scrollableItems = [];
		const sections = ['room', 'feature', 'update'];

		sections.forEach(section => {
			(this.schemasS.query(this.document, `$..${section}s`) || []).map(items => {
				const resp = [];
				for (let i = 0; i < items.length; i++) {
					const menuItem = {
						title: `${section}s`,
						section: section,
						index: i
					};
					scrollableItems.push(menuItem);
				}
				return resp;
			});
		});

		return scrollableItems;
	}

	/**
	 * Get leftNav menu items
	 * @param items
	 */
	getMenuItems(items?: any[]): any {
		let menuItems = [];

		switch (this.order.schema) {
			case SCHEMA_TYPE.CVDS_3:
				menuItems = this.getMenuItemsCVDS30();
				break;
			case SCHEMA_TYPE.CVDS_32:
				menuItems = this.getMenuItemsCVDS32();
				break;
			case SCHEMA_TYPE.CVDS_33:
				menuItems = this.getMenuItemsCVDS33();
				break;
			case SCHEMA_TYPE.CVDS_34:
				menuItems = this.getMenuItemsCVDS34(items);
				break;
			case SCHEMA_TYPE.CVDS_40:
				menuItems = this.getMenuItemsCVDS40(items);
				break;
		}

		return menuItems;
	}

	/**
	 * Get left side menu items for CVDS 3.0
	 * @private
	 */
	private getMenuItemsCVDS30(): Array<any> {
		const baseUrl = `/desktop/order/form/${this.order.id}/interior`;
		const menuItems: any = [];

		menuItems.push({
			section: 'Quality Review',
			items: [
				{
					id: 'overview-section',
					label: 'Overview',
					route: `/desktop/order/form/${this.order.id}/overview`,
					module: 'appraisal-desktop',
					icon: 'fa-dot-circle',
					scrollable: true,
				},
				{
					label: 'Modification History',
					route: `/desktop/order/historical/${this.order.id}`,
					module: 'appraisal-desktop',
					icon: 'fa-history'
				}
			]
		});

		menuItems.push({
			section: 'Subject & Market',
			items: [
				{
					id: 'subject-section',
					label: 'Subject',
					route: `/desktop/order/form/${this.order.id}/subject`,
					module: 'appraisal-desktop',
					icon: 'fa-address-book',
					scrollable: true,
				},
				{
					id: 'neighborhood-section',
					label: 'Neighborhood',
					route: `/desktop/order/form/${this.order.id}/neighborhood`,
					module: 'appraisal-desktop',
					icon: 'fa-building',
					scrollable: true,
				},
				{
					id: 'site-section',
					label: 'Site',
					route: `/desktop/order/form/${this.order.id}/site`,
					module: 'appraisal-desktop',
					icon: 'fa-warehouse',
					scrollable: true,
				}
			]
		});

		const allStructures = this.schemasS.query(this.document, `$..structures[*]`) || [];
		const allUnits = this.schemasS.query(this.document, `$..units[*]`) || [];

		// Get all Room where position is Exterior
		const allExterior = (this.schemasS.query(this.document, `$..rooms[?(@.position=="Exterior" && @.isOutsideArea==true)]`) || [])
			.filter(room => 'roomName' in room && room.roomName !== null && room.roomName !== '');
		const extSmartTags = this.schemasS.query(this.document, `$..property.smartTags[*]`) || [];

		if (allExterior.length > 0 || extSmartTags.length > 0) {
			menuItems.push({
				label: 'Exterior',
				route: `/desktop/order/form/${this.order.id}/exterior/room/-`,
				module: 'appraisal-desktop',
				icon: 'fa-road'
			});
			// Fill all Exterior Rooms
		}

		// Fill All Interior by Structure Type
		for (let structureI = 0; structureI < allStructures.length; structureI++) {
			const structure = allStructures[structureI];

			const units = [];
			for (let unitI = 0; unitI < structure.units.length; unitI++) {
				const unit = structure.units[unitI];
				const levels = [];

				for (let levelI = 0; levelI < unit.levels.length; levelI++) {
					const level = unit.levels[levelI];

					const rooms = [];
					for (let roomI = 0; roomI < level.rooms.length; roomI++) {
						const room = level.rooms[roomI];
						// if (room.position
						// 	&& room.position !== ROOM_POSITION.EXTERIOR
						// 	&& room.isOutsideArea === false
						// 	&& room.roomName
						// 	&& room.roomName !== null
						// 	&& room.roomName !== ''
						// ) {
						rooms.push({
							id: `rooms-${structureI}-${unitI}-${levelI}-${roomI}`,
							route: `${baseUrl}/rooms/${structureI}-${unitI}-${levelI}-${roomI}`,
							label: (room.roomName) ? room.roomName : room.roomType,
							scrollable: true
						});
						// }
					}

					// If Room match, then we can create the Parents
					if (rooms.length > 0) {
						levels.push({
							id: `levels-${structureI}-${unitI}-${levelI}`,
							route: `${baseUrl}/rooms/${structureI}-${unitI}-${levelI}`,
							label: (level.levelName) ? level.levelName : `Levels ${levelI}`,
							icon: 'fa-door-open',
							scrollable: true,
							items: rooms
						});

						// Section is the Structure Type
						menuItems.push({
							section: `${structure.structureType} (S${structureI + 1})`,
							items: levels
						});
					}
				}
			}
		}

		return menuItems;
	}

	/**
	 * Get left side menu items for CVDS 3.2
	 */
	private getMenuItemsCVDS32(): Array<any> {
		const menuItems = [];
		const baseUrl = `/desktop/order/review/${this.order.id}`;
		const sections = {
			room: {
				title: 'Rooms',
				icon: 'fa-door-open',
				json: 'rooms',
				label: {
					primary: 'roomType',
					secondary: 'otherDescription'
				}
			},
			feature: {
				title: 'Features',
				icon: 'fa-warehouse',
				json: 'features',
				label: {
					primary: 'description'
				}
			},
			update: {
				title: 'Updates',
				json: 'updates',
				icon: 'fa-certificate',
				label: {
					primary: 'description'
				}
			}
		};

		menuItems.push({
			label: 'Overview',
			route: `/desktop/order/overview/${this.order.id}`,
			module: 'appraisal-desktop',
			icon: 'fa-dot-circle'
		});

		menuItems.push({
			label: 'Modification History',
			route: `/desktop/order/historical/${this.order.id}`,
			module: 'appraisal-desktop',
			icon: 'fa-history'
		});

		let globalRoomIndex = 2;
		Object.keys(sections).forEach((sectionName: any, sectionIndex: number) => {
			const section = sections[sectionName];

			(this.schemasS.query(this.document, `$..${section.json}`) || []).map(items => {
				const sectionRooms = [];
				for (let i = 0; i < items.length; i++) {
					const photos = this.photos.filter(photo => {
						return photo.refJsonPath === `InspectionReport.property.${section.json}[${i}]`;
					});

					let preDescription = items[i][section.label.primary];

					preDescription = this.schemasS.getEnumeratedValue(
						`$..${section.json}.${section.label.primary}`,
						items[i][section.label.primary]
					) || '';

					if ('secondary' in section.label) {
						if (items[i][section.label.primary] === 'OTHER_ROOM') {
							preDescription = items[i][section.label.secondary];
						}
					}

					const label = preDescription.length > 12 ? `${preDescription.substring(0, 12)}...` : preDescription;

					const menuItem = {
						id: globalRoomIndex,
						label: label,
						route: `${baseUrl}/${sectionName}/${i}`,
						module: 'appraisal-desktop',
						scrollable: true,
						scrollIndex: globalRoomIndex - 2,
						title: section.title,
						icon: section.icon,
						badge: photos.length,
						hideDivider: true,
						badgeIcon: 'fas fa-image',
						collapsible: false
					};
					if (i === 0) {
						menuItem.collapsible = true;
					}

					sectionRooms.push(menuItem);
					globalRoomIndex++;
				}

				if (sectionRooms.length > 0) {
					menuItems.push({
						id: sectionRooms[0].id,
						route: sectionRooms[0].route,
						label: `${section.title}`,
						icon: 'none',
						badge: sectionRooms.length,
						hideDivider: true,
						badgeCounter: true,
						scrollable: true,
						items: sectionRooms
					});
				}

			});
		});

		return menuItems;
	}

	/**
	 * Get left side menu items for CVDS 3.3
	 * @private
	 */
	private getMenuItemsCVDS33(): Array<any> {
		const exteriorURL = `/desktop/order/form/${this.order.id}/exterior`;
		const interiorURL = `/desktop/order/form/${this.order.id}/interior`;

		const menuItems: any = [];

		// Get all Structures
		const allStructures = this.schemasS.query(this.document, `$..structures[*]`) || [];
		const allUnits = this.schemasS.query(this.document, `$..units[*]`) || [];

		// Get all Room where position is Exterior
		const allExterior = (this.schemasS.query(this.document, `$..rooms[?(@.position=="Exterior" && @.isOutsideArea==true)]`) || [])
			.filter(room => 'roomName' in room && room.roomName !== null && room.roomName !== '');
		const extSmartTags = this.schemasS.query(this.document, `$..property.smartTags[*]`) || [];

		// Iterate all Structures
		for (let structureI = 0; structureI < allStructures.length; structureI++) {
			const structure = allStructures[structureI];

			// Iterate all Unit/Levels
			const exteriorLevels = [];
			const interiorLevels = [];
			for (let unitI = 0; unitI < structure.units.length; unitI++) {
				const unit = structure.units[unitI];

				for (let levelI = 0; levelI < unit.levels.length; levelI++) {
					const level = unit.levels[levelI];

					const exteriorRooms = [];
					const interiorRooms = [];
					for (let roomI = 0; roomI < level.rooms.length; roomI++) {
						const room = level.rooms[roomI];

						// Validate it is a valid Room
						if (room.position && room.roomName
							&& room.roomName !== null
							&& room.roomName !== '') {
							// tslint:disable-next-line:max-line-length
							const photos = this.viewsServices.flattenedPhotos[`InspectionReport.property.structures[${structureI}].units[${unitI}].levels[${levelI}].rooms[${roomI}]`];
							if (photos && photos.length > 0) {
								// Exterior Type
								if (room.position === ROOM_POSITION.EXTERIOR && room.isOutsideArea === true) {
									exteriorRooms.push({
										id: `rooms-${structureI}-${unitI}-${levelI}-${roomI}`,
										route: `/desktop/order/form/${this.order.id}/interior`,
										label: room.roomName,
										scrollable: true
									});
									// Interior Type
								} else if (room.position !== ROOM_POSITION.EXTERIOR && room.isOutsideArea === false) {
									interiorRooms.push({
										id: `rooms-${structureI}-${unitI}-${levelI}-${roomI}`,
										route: `/desktop/order/form/${this.order.id}/interior`,
										label: room.roomName,
										scrollable: true
									});
								}
							}
						}
					}

					if (exteriorRooms.length > 0) {
						exteriorLevels.push({
							id: exteriorRooms[0].id,
							route: exteriorRooms[0].route,
							label: `Ext: ${level.levelName}`,
							icon: 'fas fa-road',
							scrollable: true,
							items: exteriorRooms
						});
					}
					if (interiorRooms.length > 0) {
						interiorLevels.push({
							id: interiorRooms[0].id,
							route: interiorRooms[0].route,
							label: `Int: ${level.levelName}`,
							icon: 'fa-door-open',
							scrollable: true,
							items: interiorRooms
						});
					}
				}
			}

			const allLevels = exteriorLevels.concat(interiorLevels);
			return allLevels;
		}

		return menuItems;
	}

	/**
	 * Get left side menu items for CVDS 3.4
	 * @private
	 */
	private getMenuItemsCVDS34(menuItems: any = []): Array<any> {

		this.populateExtraMenuData(menuItems);

		// If it has Rules that could break the UI
		if (this.order
			&& this.order.insideMapsRuleEnabled
			&& this.order.insideMapsRuleEnabled === true
			&& this.userPermision.hasPermission(PERMISSION.INVISION_DESKTOP_DATA_ANALYST)
		) {
			menuItems.unshift({
				label: 'Invalid Data',
				route: `/desktop/order/revised-rules/${this.order.id}`,
				module: 'appraisal-desktop',
				icon: 'fa-exclamation-circle',
				scrollable: false
			});
		}

		return menuItems;
	}

	/**
	 * Get left side menu items for CVDS 4.0
	 * @private
	 */
	private getMenuItemsCVDS40(menuItems: any = []): Array<any> {

		this.populateExtraMenuData(menuItems, true);

		const addressVerifyPhotos = this.viewsServices.flattenedPhotos['InspectionReport.property.address'] || [];

		if (addressVerifyPhotos && addressVerifyPhotos.length) {
			menuItems.unshift(
				{
					icon: 'fas fa-shield-check',
					id: 'address-0',
					label: 'Address Verification',
					route: `/desktop/order/view/${this.order.id}/review`,
					path: 'InspectionReport.property.address',
					sectionType: 'address',
					scrollable: true,
				});
		}

		menuItems.unshift(
			{
				icon: 'fas fa-file-alt',
				id: 'property-0',
				label: 'Property Data',
				route: `/desktop/order/view/${this.order.id}/review`,
				path: 'InspectionReport',
				sectionType: 'property',
				scrollable: true,
			},
			{
				icon: 'fas fa-map',
				id: 'map-0',
				label: 'Location',
				route: `/desktop/order/view/${this.order.id}/review`,
				path: 'InspectionReport.property',
				sectionType: 'map',
				scrollable: true,
			});

		// If it has Rules that could break the UI
		if (this.order
			&& this.order.insideMapsRuleEnabled
			&& this.order.insideMapsRuleEnabled === true
			&& this.userPermision.hasPermission(PERMISSION.INVISION_DESKTOP_DATA_ANALYST)
		) {
			menuItems.unshift({
				label: 'Invalid Data',
				route: `/desktop/order/revised-rules/${this.order.id}`,
				module: 'appraisal-desktop',
				icon: 'fa-exclamation-circle',
				scrollable: false
			});
		}

		return menuItems;
	}

	/**
	 * Iterate the menu recursively
	 * @param menuItems
	 * @private
	 */
	private populateExtraMenuData(menuItems: any[], sketchPerLevel = false): void {
		for (let menuItemI = 0; menuItemI < menuItems.length; menuItemI++) {
			// Used by now, will be a global property when we switch all menu apps to the new one
			menuItems[menuItemI].scrollable = true;
			let type = '';
			let icon = '';

			if (menuItems[menuItemI].id) {
				if (menuItems[menuItemI].id.indexOf('structures') >= 0) {
					if (menuItems[menuItemI].park) {
						icon = 'fas fa-warehouse';
						menuItems[menuItemI].sectionType = 'structure';
						menuItems[menuItemI].label = 'Park: ' + menuItems[menuItemI].label;
					} else {
						icon = 'fas fa-home-alt';
					}
					menuItems[menuItemI].icon = icon;

					if (sketchPerLevel && !menuItems[menuItemI].park) {
						const childLevels = menuItems[menuItemI].items;
						if (childLevels && childLevels[0]) {
							let sketchLevel = null;
							// Multi units, we chose instead the child of the unit
							if (childLevels[0].id.indexOf('units') !== -1) {
								sketchLevel = childLevels[0].items[0]
							} else {
								sketchLevel = childLevels[0];
							}
							if (sketchLevel && sketchLevel !== null) {
								menuItems[menuItemI].sketchLevel = {
									id: sketchLevel.id,
									label: 'Sketch ' + sketchLevel.label,
									path: sketchLevel.path
								};
							}
						}
					}
				} else if (menuItems[menuItemI].id.indexOf('units') >= 0) {
					menuItems[menuItemI].sectionType = 'unit';
					menuItems[menuItemI].icon = 'fas fa-th-large';
				} else if (menuItems[menuItemI].id.indexOf('levels') >= 0) {
					menuItems[menuItemI].sectionType = 'level';
					if (menuItems[menuItemI].type && menuItems[menuItemI].type === 'Exterior') {
						type = 'Ext: ';
						icon = 'fas fa-road';
					} else if (menuItems[menuItemI].type && menuItems[menuItemI].type === 'Interior') {
						type = 'Int: ';
						if (menuItems[menuItemI].park) {
							icon = 'fas fa-garage-car';
						} else {
							icon = 'fa-door-open';
						}
					}

					menuItems[menuItemI].label = type + menuItems[menuItemI].label;
					menuItems[menuItemI].icon = icon;
				} else if (menuItems[menuItemI].id.indexOf('rooms') >= 0) {
					menuItems[menuItemI].sectionType = 'room';
				}
				// We don't really do anything right now with the route
				menuItems[menuItemI].route = `/desktop/order/view/${this.order.id}/review`;
			}

			if (menuItems[menuItemI].items && menuItems[menuItemI].items.length > 0) {
				this.populateExtraMenuData(menuItems[menuItemI].items, sketchPerLevel);
				const menuItem = ObjectUtils.getFirstElementWith(menuItems[menuItemI].items, 'items', 'route');
				if (menuItem) {
					menuItems[menuItemI].id = menuItem.id;
				}
			}
		}

		// Add Sketch Level Item
		if (sketchPerLevel) {
			for (let menuItemI = 0; menuItemI < menuItems.length; menuItemI++) {
				if (menuItems[menuItemI].sketchLevel) {
					menuItems[menuItemI].items.unshift({
						id: menuItems[menuItemI].sketchLevel.id,
						label: menuItems[menuItemI].sketchLevel.label,
						path: menuItems[menuItemI].sketchLevel.path,
						route: `/desktop/order/view/${this.order.id}/review`,
						sectionType: 'level',
						icon: 'fas fa-layer-group',
						type: '',
						items: [],
						scrollable: true
					});
				}
			}
		}
	}
}
